function queryOptions(options) {
  return options;
}

export { queryOptions };
//# sourceMappingURL=queryOptions.mjs.map
